import Mock from './mock';
import { getEnv } from 'ecx.saigon.ui.common';
import { getLease as query } from '../graphql/lease';
import apolloClient from '../../utils/apollo-client';

export default async function (leaseId) {
  const env = await getEnv();
  if (env.VUE_APP_USE_MOCK) {
    const data = Mock.data.getLease;
    data.id = leaseId;
    return data;
  }

  const response = await apolloClient().then((client) =>
    client.query({
      query,
      variables: { leaseId }
    })
  );
  return response.data.getLease;
}
